import React, {Component} from 'react';
import FilterOption from "./FilterOption";
import FilterDescription from "./FilterDescription";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronDown} from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

class FilterDropdown extends Component {
    state = {
        closed: true,
    };

    toggle = () => {
        this.setState(state => ({
            closed: !state.closed,
        }))
    };
    
    onChanged = (filterItemId) => {
        const {filter, onChanged} = this.props;
        onChanged(filter.Id, filterItemId);
    };

    render() {
        const {filter, isDiscounted} = this.props;
        const {closed} = this.state;

        return <div className="border-bottom mt-npixel">
            <div className={`py-2 line-height-2-5 d-flex justify-content-between align-items-center cursor-pointer ${isDiscounted ? 'text-pink' : ''} text-hover-primary`} onClick={this.toggle}>
                <div className="font-weight-medium font-size-0-75">{filter.Name}</div>
                <div className="flex-shrink-0">
                    {filter.Description && <FontAwesomeIcon icon={faInfoCircle} className="font-size-0-75 text-center" />}
                    <FontAwesomeIcon icon={faChevronDown} className="mx-2 font-size-0-75 w-p16 text-center" />
                </div>
            </div>
            {!closed &&
                <>
                    <div className="pb-2">
                        {filter.FilterItems.map((filterItem, index) => <FilterOption filterItem={filterItem} isChecked={filterItem.FilterItemState === 1 || filterItem.FilterItemState === 2} isDisabled={filterItem.FilterItemState === 2 || filterItem.FilterItemState === 3} key={index} onChanged={this.onChanged}/>)}
                    </div>
                    {filter.Description && <FilterDescription description={filter.Description} />}
                </>
            }
           
        </div>
    }
}

export default FilterDropdown;
